import dayjs from 'dayjs';

export interface SuiviFacture {
    numeroFacture: string;
    adresseSite: string;
    libelleExterneProjet: string;
    fournisseur: string;
    etablissementLibelle: string;
    raisonSociale: string;
    dateFacture: string;
    dateEcheance: string;
    montantTtc: string;
    soldeTtc: string;
    nbJourRetard: number;
    nbJourAvantEcheance: number;
    devise: string;
    societeId: number;
    pdfExist: boolean;
}

export class SuiviFactureEnRetard {
    public numeroFacture: string;
    public societe: string;
    public etablissement: string;
    public site: string;
    public fournisseur: string;
    public dateFacture: string;
    public montantTtc: string;
    public soldeTtc: string;
    public dateEcheance: string;
    public nbJourRetard: number;
    public pdfExist: boolean;

    constructor(obj: SuiviFacture) {
        this.numeroFacture = obj?.numeroFacture ?? '';
        this.societe = obj.raisonSociale;
        this.etablissement = obj.etablissementLibelle;
        this.site = obj.adresseSite ? obj.adresseSite : obj.libelleExterneProjet;
        this.fournisseur = obj.fournisseur;
        this.dateFacture = dayjs(obj?.dateFacture).format('DD/MM/YYYY') ?? '';
        this.montantTtc = `${montantWithSpace(obj?.montantTtc) ?? 0} ${ obj?.devise}`;
        this.soldeTtc = `${montantWithSpace(obj?.soldeTtc) ?? ''} ${ obj?.devise}`;
        this.dateEcheance = dayjs(obj?.dateEcheance).format('DD/MM/YYYY') ?? '';
        this.nbJourRetard = obj?.nbJourRetard ?? 0;
        this.pdfExist = obj?.pdfExist ?? false;
    }
}

export class SuiviFactureAvantEcheance {
    public numeroFacture: string;
    public societe: string;
    public etablissement: string;
    public site: string;
    public fournisseur: string;
    public dateFacture: string;
    public montantTtc: string;
    public soldeTtc: string;
    public dateEcheance: string;
    public nbJourAvantEcheance: number;
    public pdfExist: boolean;

    constructor(obj: SuiviFacture) {
        this.numeroFacture = obj?.numeroFacture ?? '';
        this.societe = obj.raisonSociale;
        this.etablissement = obj.etablissementLibelle;
        this.site = obj.adresseSite ? obj.adresseSite : obj.libelleExterneProjet;
        this.fournisseur = obj.fournisseur;
        this.dateFacture = dayjs(obj?.dateFacture).format('DD/MM/YYYY') ?? '';
        this.montantTtc = `${montantWithSpace(obj?.montantTtc) ?? 0} ${ obj?.devise}`;
        this.soldeTtc = `${montantWithSpace(obj?.soldeTtc) ?? ''} ${ obj?.devise}`;
        this.dateEcheance = dayjs(obj?.dateEcheance).format('DD/MM/YYYY') ?? '';
        this.nbJourAvantEcheance = obj?.nbJourAvantEcheance ?? 0;
        this.pdfExist = obj?.pdfExist ?? false;
    }
}

export class SuiviFacturePayees {
    public numeroFacture: string;
    public societe: string;
    public etablissement: string;
    public site: string;
    public fournisseur: string;
    public dateFacture: string;
    public montantTtc: string;
    public dateEcheance: string;
    public pdfExist: boolean;

    constructor(obj: SuiviFacture) {
        this.numeroFacture = obj?.numeroFacture ?? '';
        this.societe = obj.raisonSociale;
        this.etablissement = obj.etablissementLibelle;
        this.site = obj.adresseSite ? obj.adresseSite : obj.libelleExterneProjet;
        this.fournisseur = obj.fournisseur;
        this.dateFacture = dayjs(obj?.dateFacture).format('DD/MM/YYYY') ?? '';
        this.montantTtc = `${montantWithSpace(obj?.montantTtc) ?? 0} ${ obj?.devise}`;
        this.dateEcheance = dayjs(obj?.dateEcheance).format('DD/MM/YYYY') ?? '';
        this.pdfExist = obj?.pdfExist ?? false;
    }
}

const montantWithSpace = (montant: string) => {
    //Ajoute un espace tout les 3 chiffres pour éviter un effet tout coller
    return (Math.round(parseFloat(montant) * 100) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
